import React from 'react'
import propTypes from 'prop-types'
import { Grid, Typography, makeStyles } from '@material-ui/core'
import DescriptionIcon from '@material-ui/icons/Description'
import ImageIcon from '@material-ui/icons/Image'
import VideoIcon from '@material-ui/icons/PlayCircleOutline'
import LinkIcon from '@material-ui/icons/Link'
import TypeCard from './components/TypeCard'

const useStyles = makeStyles((theme) => ({
	heading: {
		marginBottom: theme.spacing(2),
		fontWeight: 600,
		color: theme.palette.text.primary
	},
	readOnlyCaption: {
		marginTop: theme.spacing(2),
		color: theme.palette.text.secondary,
		fontStyle: 'italic'
	}
}))

const TYPE_DEFS = [
	{ value: 'document', icon: DescriptionIcon, title: 'Document', description: 'PDF · max 50MB', datacy: 'wizard-type-document' },
	{ value: 'image', icon: ImageIcon, title: 'Image', description: 'JPG, PNG · max 50MB', datacy: 'wizard-type-image' },
	{ value: 'video', icon: VideoIcon, title: 'Video', description: 'MP4, MOV · max 50MB', datacy: 'wizard-type-video' },
	{ value: 'link', icon: LinkIcon, title: 'Link', description: 'External URL', datacy: 'wizard-type-link' }
]

const Step1Type = ({ onSelectType, readOnly, selectedType }) => {
	const classes = useStyles()
	return (
		<>
			<Typography variant='subtitle1' className={classes.heading}>
				{readOnly ? 'Resource type' : 'What type of resource will you upload?'}
			</Typography>
			<Grid container spacing={2}>
				{TYPE_DEFS.map((def) => (
					<Grid item xs={12} sm={6} key={def.value}>
						<TypeCard
							icon={def.icon}
							title={def.title}
							description={def.description}
							onClick={() => onSelectType(def.value)}
							datacy={def.datacy}
							disabled={readOnly}
							selected={readOnly && selectedType === def.value}
						/>
					</Grid>
				))}
			</Grid>
			{readOnly && (
				<Typography variant='caption' className={classes.readOnlyCaption}>
					Type cannot be changed.
				</Typography>
			)}
		</>
	)
}

Step1Type.propTypes = {
	onSelectType: propTypes.func.isRequired,
	readOnly: propTypes.bool,
	selectedType: propTypes.string
}

Step1Type.defaultProps = {
	readOnly: false,
	selectedType: null
}

export default Step1Type
